<template>
  <div>
    <el-menu
      class="base-header"
      mode="horizontal"
      :background-color="backgroundColor"
      text-color="#f8f8ff"
      active-text-color="#ffd04b"
      :default-active="activeIndex()"
    >
      <h3 class="header-title unit-header-title">SIPS</h3>
      <el-sub-menu
        v-if="displayItem(['ACCEPT', 'BULK_ACCEPT', 'ADVANCE_ACCEPT'])"
        index="1"
      >
        <template #title>受注管理</template>
        <el-menu-item
          v-if="displayItem(['ACCEPT'])"
          index="accept"
          class="unit-header-item-accept"
          @click="routerPush('/accept')"
        >
          受注情報
        </el-menu-item>
        <el-menu-item
          v-if="displayItem(['BULK_ACCEPT'])"
          index="bulk"
          class="unit-header-item-bulk"
          @click="routerPush('/bulk')"
        >
          バルク受注
        </el-menu-item>
        <el-menu-item
          v-if="displayItem(['ADVANCE_ACCEPT'])"
          index="advance"
          class="unit-header-item-bulk"
          @click="routerPush('/advance')"
        >
          先行受注
        </el-menu-item>
      </el-sub-menu>
      <el-menu-item
        v-if="displayItem(['RECEIVE'])"
        index="receive"
        class="unit-header-item-receive"
        @click="routerPush('/receive')"
      >
        入荷管理
      </el-menu-item>
      <el-menu-item
        v-if="displayItem(['SHIPPING'])"
        index="ship"
        class="unit-header-item-ship"
        @click="routerPush('/ship')"
      >
        出荷管理
      </el-menu-item>
      <el-menu-item
        v-if="displayItem(['MGMT'])"
        index="management"
        class="unit-header-item-management"
        @click="routerPush('/management')"
      >
        総合管理
      </el-menu-item>
      <el-sub-menu v-if="displayItem(['UNRECORD', 'SALE'])" index="2">
        <template #title>請求管理</template>
        <el-menu-item
          v-if="displayItem(['UNRECORD'])"
          index="unrecord"
          @click="routerPush('/unrecord')"
        >
          未計上受注
        </el-menu-item>
        <el-menu-item
          v-if="displayItem(['SALE'])"
          index="sale"
          @click="routerPush('/sale')"
        >
          売上一覧
        </el-menu-item>
      </el-sub-menu>
      <el-sub-menu
        v-if="displayItem(['ORDER', 'PURCHASE', 'MOVE', 'INVENTORY', 'STOCK'])"
        index="3"
      >
        <template #title>在庫管理</template>
        <el-menu-item
          v-if="displayItem(['ORDER'])"
          index="order"
          @click="routerPush('/order')"
        >
          発注
        </el-menu-item>
        <el-menu-item
          v-if="displayItem(['PURCHASE'])"
          index="purchase"
          @click="routerPush('/purchase')"
        >
          仕入
        </el-menu-item>
        <el-menu-item
          v-if="displayItem(['MOVE'])"
          index="move"
          @click="routerPush('/move')"
        >
          移動
        </el-menu-item>
        <el-menu-item
          v-if="displayItem(['INVENTORY'])"
          index="inventory"
          @click="routerPush('/inventory/')"
        >
          棚卸
        </el-menu-item>
        <el-menu-item
          v-if="displayItem(['STOCK'])"
          index="stock"
          @click="routerPush('/stock')"
        >
          在庫一覧表
        </el-menu-item>
      </el-sub-menu>
      <el-sub-menu v-if="displayItem(['DEVICE_II', 'DEVICE_III'])" index="4">
        <template #title>端末管理</template>
        <el-menu-item index="device3" @click="routerPush('/device/3')">
          MCCSⅢ
        </el-menu-item>
        <el-menu-item index="device2" @click="routerPush('/device/2')">
          MCCSⅡ
        </el-menu-item>
      </el-sub-menu>
      <el-sub-menu
        v-if="displayItem(['CARSEC_III', 'CARSEC_II', 'CARSEC_HARNESS'])"
        index="carSecurityDevice"
      >
        <template #title>カーセキュリティ</template>
        <el-menu-item
          v-if="displayItem(['CARSEC_III'])"
          index="carSecuritydevice3"
          @click="routerPush('/carSecurity/device/3')"
        >
          MCCSⅢ 端末管理
        </el-menu-item>
        <el-menu-item
          v-if="displayItem(['CARSEC_II'])"
          index="carSecuritydevice2"
          @click="routerPush('/carSecurity/device/2')"
        >
          MCCSⅡ 端末管理
        </el-menu-item>
        <el-menu-item
          v-if="displayItem(['CARSEC_HARNESS'])"
          index="carSecurityHarness"
          @click="routerPush('/carSecurityHarness')"
        >
          スマブロ適合表
        </el-menu-item>
      </el-sub-menu>
      <el-menu-item
        v-if="displayItem(['DEVICE_T'])"
        index="device11"
        class="unit-header-item-device"
        @click="routerPush('/device/11')"
      >
        Type T
      </el-menu-item>
      <el-menu-item
        v-if="
          displayItem([
            'SUB_CATEGORY',
            'ITEM',
            'PACKAGE',
            'PRODUCT',
            'FINANCE',
            'COMPANY_GROUP',
            'COMPANY',
            'SHOP',
            'SUPPORT_SHOP',
            'SUPPLIER',
            'CAR',
            'CAR_MAKER',
            'MCCS_SETTINGS_ITEM',
            'MCCS_FINANCE_SETTINGS',
            'ORDER_AUTO_MAP',
            'ROLE_PERMISSION_SETTINGS'
          ])
        "
        index="master"
        class="unit-header-item-master"
        @click="routerPush('/master')"
      >
        マスタ管理
      </el-menu-item>
      <el-menu-item
        v-if="displayItem(['HARNESS'])"
        index="harness"
        class="unit-header-item-master"
        @click="routerPush('/harness')"
      >
        ハーネス適合表
      </el-menu-item>
      <el-menu-item
        v-if="displayItem(['USER'])"
        class="unit-header-item-user"
        index="user"
        @click="routerPush('/user')"
      >
        ユーザー管理
      </el-menu-item>
      <el-menu-item
        v-if="displayItem(['ACTIVATION'])"
        class="unit-header-item-user"
        index="activation"
        @click="routerPush('/activation')"
      >
        起動制御解除
      </el-menu-item>
      <el-sub-menu v-if="displayItem(['MSPF'])" index="6">
        <template #title>MSPF</template>
        <el-menu-item
          v-if="displayItem(['MSPF'])"
          index="6-1"
          class="unit-header-item-bulk"
          @click="moveMSPF('operation')"
        >
          Operator
        </el-menu-item>
      </el-sub-menu>
    </el-menu>
    <el-dialog v-model="dialogVisible" title="確認" width="400px">
      <span><b>SIPS画面からログアウトします。</b></span>
      <template #footer>
        <el-button @click="dialogVisible = false">キャンセル</el-button>
        <el-button type="primary" @click="logout"> ログアウト </el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';
  import router from '@/router';
  import { useRoute } from 'vue-router';
  import { hasScreenCodePermission } from '@/libs/auth';
  import { signOut } from '@/libs/firebaseAuth';
  import { getEnv } from '@/libs/env';

  export default defineComponent({
    name: 'BaseHeader',
    setup() {
      const route = useRoute();
      const dialogVisible = false;

      const logout = async () => {
        await signOut();
        router.push('/login');
      };
      const displayItem = (permissionCodes: string[] | null = null) => {
        const isPublic = route.meta?.isPublic;

        if (isPublic) return false;
        if (!permissionCodes || permissionCodes.length === 0) return true;
        return permissionCodes.some((code) =>
          hasScreenCodePermission(code, 'VIEW')
        );
      };
      // const activeIndex = () => {
      //   return route.path.split('/')[1];
      // };

      const activeIndex = () => {
        const pathSegments = route.path.split('/');
        return (
          pathSegments[1] +
          (pathSegments[2] ? pathSegments[2] : '') +
          (pathSegments[3] ? pathSegments[3] : '')
        );
      };
      const routerPush = (path: string) => {
        if (route.path === path) return;
        router.push(path);
      };
      const moveMSPF = (path: string) => {
        window.open(
          import.meta.env.VITE_APP_MSPF_OPERATOR_URL + '/' + path,
          '_blank'
        );
      };
      const backgroundColor = getEnv() === 'staging' ? '#797979' : '#0148a0';
      return {
        dialogVisible,
        logout,
        displayItem,
        activeIndex,
        routerPush,
        moveMSPF,
        backgroundColor
      };
    }
  });
</script>
<style lang="scss">
  .base-header {
    z-index: 1000;

    .header-title {
      font-size: 30px;
      font-weight: 800;
      float: left;
      color: #ffffff;
      margin: 8px 10px;
      pointer-events: none;
    }

    li {
      font-weight: 600;
    }
  }

  .header-link-text {
    color: #ffffff;
  }

  .el-menu--horizontal {
    &.el-menu--popup-container {
      height: 20px;
    }

    .el-sub-menu.header-menu-right {
      float: right;
    }
  }

  .el-menu.el-menu--horizontal {
    position: fixed;
    width: 100%;
  }
</style>
